/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetOrderEmployeeDto } from './GetOrderEmployeeDto';
import {
    GetOrderEmployeeDtoFromJSON,
    GetOrderEmployeeDtoFromJSONTyped,
    GetOrderEmployeeDtoToJSON,
} from './GetOrderEmployeeDto';
import type { GetOrderEstimateItemDto } from './GetOrderEstimateItemDto';
import {
    GetOrderEstimateItemDtoFromJSON,
    GetOrderEstimateItemDtoFromJSONTyped,
    GetOrderEstimateItemDtoToJSON,
} from './GetOrderEstimateItemDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetOrderDto
 */
export interface GetOrderDto {
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    id: string;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetOrderDto
     */
    project: GetProjectDto;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetOrderDto
     */
    resultProject: GetProjectDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetOrderDto
     */
    team: GetTeamDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderDto
     */
    addTeamToEmails: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOrderDto
     */
    emails: Array<string>;
    /**
     * 
     * @type {Array<GetOrderEstimateItemDto>}
     * @memberof GetOrderDto
     */
    orderEstimateItems?: Array<GetOrderEstimateItemDto>;
    /**
     * 
     * @type {Array<GetOrderEmployeeDto>}
     * @memberof GetOrderDto
     */
    orderEmployees?: Array<GetOrderEmployeeDto>;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    status: GetOrderDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    rejectedNote: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetOrderDto
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetOrderDto
     */
    creationTs: Date;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetOrderDto
     */
    pathPhaseDictionary?: GetDictionaryDto;
    /**
     * 
     * @type {Date}
     * @memberof GetOrderDto
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetOrderDto
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderDto
     */
    active: boolean;
}


/**
 * @export
 */
export const GetOrderDtoStatusEnum = {
    New: 'New',
    Accepted: 'Accepted',
    Rejected: 'Rejected'
} as const;
export type GetOrderDtoStatusEnum = typeof GetOrderDtoStatusEnum[keyof typeof GetOrderDtoStatusEnum];


/**
 * Check if a given object implements the GetOrderDto interface.
 */
export function instanceOfGetOrderDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "project" in value;
    isInstance = isInstance && "resultProject" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "addTeamToEmails" in value;
    isInstance = isInstance && "emails" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "rejectedNote" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "creationTs" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetOrderDtoFromJSON(json: any): GetOrderDto {
    return GetOrderDtoFromJSONTyped(json, false);
}

export function GetOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'project': GetProjectDtoFromJSON(json['project']),
        'resultProject': GetProjectDtoFromJSON(json['resultProject']),
        'team': GetTeamDtoFromJSON(json['team']),
        'addTeamToEmails': json['addTeamToEmails'],
        'emails': json['emails'],
        'orderEstimateItems': !exists(json, 'orderEstimateItems') ? undefined : ((json['orderEstimateItems'] as Array<any>).map(GetOrderEstimateItemDtoFromJSON)),
        'orderEmployees': !exists(json, 'orderEmployees') ? undefined : ((json['orderEmployees'] as Array<any>).map(GetOrderEmployeeDtoFromJSON)),
        'systemNumber': json['systemNumber'],
        'status': json['status'],
        'rejectedNote': json['rejectedNote'],
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': (new Date(json['creationTs'])),
        'pathPhaseDictionary': !exists(json, 'pathPhaseDictionary') ? undefined : GetDictionaryDtoFromJSON(json['pathPhaseDictionary']),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'active': json['active'],
    };
}

export function GetOrderDtoToJSON(value?: GetOrderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'project': GetProjectDtoToJSON(value.project),
        'resultProject': GetProjectDtoToJSON(value.resultProject),
        'team': GetTeamDtoToJSON(value.team),
        'addTeamToEmails': value.addTeamToEmails,
        'emails': value.emails,
        'orderEstimateItems': value.orderEstimateItems === undefined ? undefined : ((value.orderEstimateItems as Array<any>).map(GetOrderEstimateItemDtoToJSON)),
        'orderEmployees': value.orderEmployees === undefined ? undefined : ((value.orderEmployees as Array<any>).map(GetOrderEmployeeDtoToJSON)),
        'systemNumber': value.systemNumber,
        'status': value.status,
        'rejectedNote': value.rejectedNote,
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': (value.creationTs.toISOString()),
        'pathPhaseDictionary': GetDictionaryDtoToJSON(value.pathPhaseDictionary),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'active': value.active,
    };
}

